import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const ModalWindowDeleteUser = (props) => {
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">Delete user '{props.username}'' ?</h4>
          <p>Do you want to delete user {props.username} ?</p>
          {props.errorMsg && (
            <span className="badge text-bg-danger">{props.errorMsg}</span>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="large-button grey" onClick={props.onHide}>
            CLOSE
          </button>
          <button
            type="button"
            onClick={props.handleSubmit}
            className="large-button red"
          >
            DELETE
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalWindowDeleteUser;
